import { Component, Input, OnInit } from '@angular/core';
import { BestScores, EventSchedule } from '@fantaz/shared/data-access/models';

@Component({
  selector: 'fz-score-summary',
  templateUrl: './score-summary.component.html',
  styleUrls: ['./score-summary.component.scss'],
})
export class ScoreSummaryComponent implements OnInit {
  @Input()
  viewEntryFee = false;
  @Input()
  eventCode?: string;
  @Input()
  isLEP: boolean | undefined;
  @Input()
  showSummary: boolean;
  @Input()
  prizeValue?: number | null;
  @Input()
  bestScore?: BestScores | null | undefined;
  @Input()
  entryAmount?: number;
  @Input()
  seats: number | undefined;
  @Input()
  prizeImage?: string | undefined;
  @Input()
  assetUrl?: string;

  @Input()
  metadata?: any | null | undefined;

  @Input()
  eventScheduleDetails: EventSchedule | null | undefined;

  tags: string[];

  ngOnInit(): void {
    this.tags = this.getTags();
  }
  /*
    This function returns the list of tags on the current page.
    If the tags are stored as a string, it splits the string into an array.
    Otherwise, it returns the array of tags.
  */
  getTags(): string[] {
    console.log('tags', this.metadata?.tags);
    // Return an empty array if the details don't exist.
    const tags = this.metadata?.tags;
    if (!tags) return [];

    // Return the array of tags if they are already an array.
    if (Array.isArray(tags)) {
      return tags;
    }

    // Return the array of tags if they are a comma-separated string.
    if ('string' === typeof tags) {
      return (tags as string).split(',');
    }

    // Log an error if the tags are a different type.
    console.warn('Unable to parse tags.');
    return [];
  }

  uniLevelPercent(): string | undefined {
    return ((this.findCorrectLevel()?.percent ?? 0) * 10).toString();
  }

  findCorrectLevel() {
    if (this.eventScheduleDetails?.uniLevelDetails) {
      for (
        let i = 0;
        i < this.eventScheduleDetails?.uniLevelDetails?.length;
        i++
      ) {
        if (this.eventScheduleDetails?.uniLevelDetails[i].level === 1) {
          return this.eventScheduleDetails?.uniLevelDetails[i];
        }
      }
    }
    return null;
  }

  referralBonus(): number | undefined {
    return this.findCorrectLevel()?.amountPerUser;
  }

  getPrize() {
    return this.prizeValue ? this.prizeValue : 0;
  }
}
